export class Wards {
  Id: string;
  Name: string;

  constructor(id: string, name: string) {
    this.Id = id;
    this.Name = name;
  }
}
